import React from 'react';
import { Card, CardTitle, Table, Badge } from 'reactstrap';

const MiniProfile = (props: {
  displayName: string;
  score: string;
  birthDate: string;
  organization: string;
  mrn: string;
}) => (
  <Card className="pb-0 pt-4 pr-3 pl-3">
    <CardTitle>
      <h3>{props.displayName}</h3>
    </CardTitle>
    <Table>
      <tbody>
        <tr>
          <td>
            <b>Date of Birth</b>
          </td>
          <td>{props.birthDate}</td>
        </tr>
        <tr>
          <td>
            <b>Organization</b>
          </td>
          <td>{props.organization}</td>
        </tr>
        <tr>
          <td>
            <b>MRN</b>
          </td>
          <td>{props.mrn}</td>
        </tr>
        <tr>
          <td>
            <b>Score</b>
          </td>
          <td>
            <h4>
              <Badge>{props.score}</Badge>
            </h4>
          </td>
        </tr>
      </tbody>
    </Table>
  </Card>
);

export default MiniProfile;
